import manoDeObraIcon from '@assets/svgs/lineasManoDeObra.svg';
import { EsfirusInputTextAreaNative } from '@components/ui/InputTextNative/EsfirusInputTextNative';
import { Capitulo } from '@models/obra';
import Grid from '@mui/material/Grid';
import EsfirusHourInput from '@ui/Hour-input/EsfirusHourInput';
import EsfirusSelect from '@ui/Select/EsfirusSelect';
import TimeInput from './components/TimeInput';
import { useLaborLinesHook } from './hooks/LaborLinesHook';
import './LineasManoDeObra.scss';
import { UserWithDataParsed } from '@models/user';

interface Categoria {
  Categoria: number;
  NombreCategoria: string;
}

function LineasManoDeObra(props: any) {
  const {
    activitiesOptions,
    allowToSelectEmpleado,
    categorias,
    categoriasOptions,
    changeLineHandler,
    descManoObra,
    empleadosOptions,
    getCategoryDisabled,
    getChapterOptions,
    getEndHour,
    getHorasFinDisabled,
    getHours,
    getNumberHoursDisabled,
    getTipoHoras,
    getTipoHorasDisabled,
    lineas,
    obtenerTipoHora,
    recalculate,
    selectedobra,
    showManoObraCategoria,
    showManoObraTipoHora,
    subActivitiesOptions,
    updateData,
    users,
    validaErrores,
    handleBlurTimeInputs,
    description,
    setDescription,
    timeMinutesStep
  } = useLaborLinesHook(props);

  return (
    <Grid
      className="line-services-container"
      container
      spacing={1}
      alignItems={'center'}
    >
      <Grid
        className="flex-row"
        item
        xs={12}
        md={2}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <img className="logo mr-10" src={manoDeObraIcon} alt="service" />
        <h4>MO</h4>
      </Grid>
      <Grid item xs={12} md={10} container spacing={2}>
        {allowToSelectEmpleado && (
          <Grid item xs={12} md={3}>
            <label>Empleado</label>
            <EsfirusSelect
              options={empleadosOptions}
              change={(e: string) => {
                const userSelected = users.find(
                  (user: UserWithDataParsed) => Number(user.id) === Number(e)
                );
                updateData(userSelected);
              }}
              value={lineas.list[props.index]?.userWorker?.id}
              disabled={!props.editable || !!lineas.list[props.index]?.idLinea}
              placeholder="Seleccionar"
            />
          </Grid>
        )}
        {selectedobra.SolActividad && (
          <>
            <Grid item xs={12} sm={6} md={3}>
              <label>Actividad</label>
              <EsfirusSelect
                options={activitiesOptions}
                optionsStyle={{ textAlign: 'left', fontWeight: 'bold' }}
                value={lineas.list[props.index]?.activity}
                disabled={!props.editable}
                change={(activity: string) => {
                  changeLineHandler({
                    ...lineas.list[props.index],
                    activity: activity,
                    subactivity: '',
                  });
                }}
                placeholder="Actividad"
                errorMessage={
                  activitiesOptions.length === 0 ? 'No hay actividades' : ''
                }
              ></EsfirusSelect>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <label>Subactividad</label>
              <EsfirusSelect
                options={subActivitiesOptions}
                optionsStyle={{ textAlign: 'left', fontWeight: 'bold' }}
                value={lineas.list[props.index]?.subactivity}
                change={(subactivity: string) => {
                  changeLineHandler({
                    ...lineas.list[props.index],
                    subactivity,
                  });
                }}
                placeholder="Subactividad"
                disabled={
                  !props.editable ||
                  !lineas.list[props.index]?.activity ||
                  !subActivitiesOptions.length
                }
                errorMessage={
                  activitiesOptions.length === 0 ? 'No hay subactividades' : ''
                }
              ></EsfirusSelect>
            </Grid>
          </>
        )}

        {!selectedobra.Administracion &&
          selectedobra.SolCapitulo &&
          selectedobra.capitulosByPresupuesto.length !== 0 &&
          !Boolean(props.isPedido) && (
            <Grid item xs={12} md={3}>
              <label>Capítulo</label>
              <EsfirusSelect
                options={getChapterOptions()}
                optionsStyle={{ textAlign: 'left', fontWeight: 'bold' }}
                value={lineas?.list[props.index]?.chapter?.Capitulo}
                change={(capitulo: string) => {
                  const selectedChapter =
                    selectedobra.capitulosByPresupuesto.find(
                      (el: Capitulo) => el.Capitulo == capitulo
                    );
                  const newTypeHour = obtenerTipoHora(
                    lineas.list[props.index],
                    { chapter: selectedChapter }
                  );

                  changeLineHandler({
                    ...lineas.list[props.index],
                    typeHour: newTypeHour,
                    chapter: selectedChapter,
                    user: lineas?.list[props.index]?.userWorker?.id,
                  });
                }}
                placeholder={'Capítulo'}
                disabled={!props.editable}
                modified={
                  !!lineas.list[props.index]?.validationModifications?.datos
                    ?.chapter
                }
              ></EsfirusSelect>
            </Grid>
          )}

        {showManoObraCategoria && (
          <Grid item xs={12} md={3}>
            <label>Categoria</label>
            <EsfirusSelect
              options={categoriasOptions}
              value={lineas.list[props.index]?.category}
              change={(e: any) => {
                const selectedCategoria = categorias.find(
                  (cat: Categoria) => cat.Categoria == e
                );

                changeLineHandler({
                  ...lineas.list[props.index],
                  category: selectedCategoria?.Categoria,
                  user: lineas?.list[props.index]?.userWorker?.id,
                });
              }}
              disabled={getCategoryDisabled()}
              modified={
                !!lineas.list[props.index]?.validationModifications?.datos
                  ?.category
              }
            ></EsfirusSelect>
          </Grid>
        )}

        {showManoObraTipoHora && (
          <Grid item xs={12} md={3}>
            <label>Tipo de hora</label>
            <EsfirusSelect
              options={getTipoHoras()}
              change={(e: string) => {
                const line = {...lineas.list[props.index]};
                line.precio = '';
                line.article = '';
                changeLineHandler({
                  ...line,
                  typeHour: e,
                  user: lineas?.list[props.index]?.userWorker?.id,
                });
              }}
              value={lineas.list[props.index]?.typeHour}
              disabled={getTipoHorasDisabled()}
              placeholder={'Tipo Hora'}
              modified={
                !!lineas.list[props.index]?.validationModifications?.datos
                  ?.typeHour
              }
            ></EsfirusSelect>
          </Grid>
        )}
        {descManoObra && (
          <Grid item xs={12} md={12}>
            <label>Descripción</label>
            <EsfirusInputTextAreaNative
              min={10}
              max={800}
              value={description}
              required={true}
              change={(val: string) => setDescription(val)}
              disabled={!props.editable}
              modified={
                !!lineas.list[props.index]?.validationModifications?.datos
                  ?.description
              }
            />
          </Grid>
        )}

        {!Boolean(lineas?.list[props.index]?.hoursAndMinutesInRaw) ? (
          <>
            <Grid item xs={6} md={2}>
              <label>Hora inicio</label>
              <EsfirusHourInput
                id={'start-time-date'}
                value={lineas?.list[props.index]?.startTime}
                change={(hour: any) => {
                  recalculate(hour, true);
                }}
                disabled={!props.editable}
                modified={
                  !!lineas.list[props.index]?.validationModifications?.datos
                    ?.startTime
                }
              />
            </Grid>

            <Grid item xs={6} md={2}>
              <label>Nº Horas</label>
              <EsfirusHourInput
                id={'number-hours-date'}
                disabled={getNumberHoursDisabled()}
                value={lineas?.list[props.index]?.numberHours}
                change={(hour: any) => {
                  const newEndTime = getEndHour(hour);
                  const newTypeHour = obtenerTipoHora(
                    lineas.list[props.index],
                    {
                      endTime: getEndHour(hour),
                      startTime: lineas?.list[props.index]?.startTime,
                    }
                  );

                  changeLineHandler({
                    ...lineas.list[props.index],
                    endTime: newEndTime,
                    numberHours: hour,
                    typeHour: newTypeHour,
                    user: lineas?.list[props.index]?.userWorker?.id,
                  });
                }}
                modified={
                  !!lineas.list[props.index]?.validationModifications?.datos
                    ?.numberHours
                }
                isQuantity
                initialHourQuantity={
                  lineas.list[props.index]?.startTime ?? '00:00'
                }
              />
            </Grid>

            <Grid item xs={6} md={2}>
              <label>Hora fin</label>
              <EsfirusHourInput
                id={'end-hours-date'}
                disabled={getHorasFinDisabled()}
                value={lineas?.list[props.index]?.endTime}
                change={(hour: any) => {
                  const newNumberHours = getHours(hour);
                  const newTypeHour = obtenerTipoHora(
                    lineas.list[props.index],
                    {
                      endTime: hour,
                      startTime: lineas?.list[props.index]?.startTime,
                    }
                  );

                  changeLineHandler({
                    ...lineas.list[props.index],
                    endTime: hour,
                    numberHours: newNumberHours,
                    typeHour: newTypeHour,
                    user: lineas?.list[props.index]?.userWorker?.id,
                  });
                }}
                modified={
                  !!lineas.list[props.index]?.validationModifications?.datos
                    ?.endTime
                }
              />
            </Grid>
          </>
        ) : (
          <>
            <TimeInput
              hours={lineas.list[props.index].hours ?? 0}
              minutes={lineas.list[props.index].minutes ?? 0}
              untilMinute={timeMinutesStep}
              disabled={!props.editable}
              onChange={({ minutes, hours }) => {

                const newTypeHour = obtenerTipoHora(lineas.list[props.index], {
                  endTime: '00:00',
                  startTime: '00:00',
                });

                changeLineHandler({
                  ...lineas.list[props.index],
                  startTime: '00:00',
                  endTime: '00:00',
                  typeHour: newTypeHour,
                  minutes,
                  hours,
                });
              }}
              onBlur={() => handleBlurTimeInputs()}
              modifiedHours={
                !!lineas.list[props.index]?.validationModifications?.datos
                  ?.hours
              }
              modifiedMinutes={
                !!lineas.list[props.index]?.validationModifications?.datos
                  ?.minutes
              }
            />
          </>
        )}

        {validaErrores(lineas.list[props.index])}
      </Grid>
    </Grid>
  );
}

export default LineasManoDeObra;
